module.exports = __webpack_public_path__ + "img/slide-img.9a5212b9.png";